// src/contexts/LanguageContext.js

import React, { createContext, useState, useEffect } from 'react';
import translations from '../translations'; // Import translations

// Create the Context
export const LanguageContext = createContext();

// Create a Provider Component
export const LanguageProvider = ({ children }) => {
  const storedLanguage = localStorage.getItem('appLanguage');
  const [language, setLanguage] = useState(storedLanguage || 'ka'); // Default language is Georgian

  const toggleLanguage = (lang) => {
    setLanguage(lang);
    try {
      localStorage.setItem('appLanguage', lang); // Persist language selection
    } catch (err) {
      console.error("Error saving language to localStorage:", err);
    }
  };

  useEffect(() => {
    // Optional: Apply language-specific settings or fetch translations if needed
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};
